firebird.factory('videoScreenShareService', [
    '$rootScope',
    '$timeout',
    '$interval',
    '$window',
    'logService',
    'connectivityService',
    'socketService',
    'helperService',
    'contentService',
    'meetingService',
    'configService',
    'screenShareService',
    'analyticsWrapperService',
    'supportLinkService',
    'notificationService',
    'localizationService',
    'videoGlobalService',
    'executionEnvironmentEnum',
    'storageService',
    'brandingService',
    function (
        $rootScope,
        $timeout,
        $interval,
        $window,
        logService,
        connectivityService,
        socketService,
        helperService,
        contentService,
        meetingService,
        configService,
        screenShareService,
        analyticsWrapperService,
        supportLinkService,
        notificationService,
        localizationService,
        videoGlobalService,
        executionEnvironmentEnum,
        storageService,
        brandingService
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoScreenShareService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.initScreenShare = initScreenShare;

            // video room plugin handle for screen share
            self.screenshare = null;

            // whether multiple content share is allowed? Can be altered via user pair, not URL param.
            self.multishare = false;
            self.multisharePrompt = 'true';

            // whether the local client is publishing screen video as a content? (only allowed if multishare is enabled)
            // if set, then the client treats it as content share publish of screen but via multishare feature to publishers.
            self.isScreenVideo = false;

            // either 'screen' or 'window'
            self.capture = null;

            // screen share publishing media stream (local media stream)
            self.screenstream = null;

            // SIP plugin handle for screen share
            self.screensipcall = null;

            // this videoroom participant ID for screen share publisher
            self.myscreenid = null;

            // this videoroom publisher ID for screen share publisher
            self.screenpvtid = null;

            // null (idle), 'initiating', 'active', 'disconnected' (will reconnect), 'stopped' (will reconnect after node sends content status)
            // if disconnected, then will keep a clone of the stream, to use after reconnection.
            self.screenshareState = null;
            self.screenstreamClone = null;

            self.createOfferForScreen = createOfferForScreen;

            self.updateScreenMediaConstraints = updateScreenMediaConstraints;

            self.preShareScreen = preShareScreen;
            self.shareScreen = shareScreen;
            self.startScreenShare = startScreenShare;
            self.stopScreenShare = stopScreenShare;
            self.setIsHostingSFUScreenShare = setIsHostingSFUScreenShare;
            self.saveScreenshareForReconnection = saveScreenshareForReconnection;

            self.doScreenHangup = doScreenHangup;
            self.onScreenShareInactive = onScreenShareInactive;
            self.handleTrackCloseOnVmware = handleTrackCloseOnVmware;

            self.detectScreenAppMute = true;

            self.enterCompactIfReconnect = true;

            self.screenRepublishRetry = 0;
            self.screenRepublishMaxRetries = 10;
            self.screenRepublishTimer = null;
            self.cancelScreenRepublishTimer = cancelScreenRepublishTimer;
            self.recreateScreenPublishPlugin = recreateScreenPublishPlugin;
            self.handleScreenPublishPluginError = handleScreenPublishPluginError;

            // when the screen share button is toggled
            $scope.$on('start-sfu-screenshare', onStartSfuScreenShare);
            $scope.$on('stop-sfu-screenshare', onStopSfuScreenShare);
            $scope.$on('sfu-screenshare-presenter-started', onScreenSharePresenterStarted);

            // screen share state is updated in node server
            $scope.$on('screenshare-started', onScreenShareStarted);
            $scope.$on('screenshare-ended', onScreenShareEnded);
        }

        // update state from URL param
        function initScreenShare() {
            // treat app screen stream mute as minimized.
            self.detectScreenAppMute = (configService.getValue('detectScreenAppMute') || 'true') === 'true';

            // do not allow query param to set this, as all participant must use the same value.
            self.multishare = configService.getHasMultishare();
            self.multisharePrompt = configService.getMultisharePrompt();

            var reuseScreenSDP = configService.getClientValue('reuseScreenSDP');
            if (reuseScreenSDP) {
                self.reuseScreenSDP.enable = reuseScreenSDP !== 'false';
            }
        }

        // apply framerate, width/height and other constraints on screen video track.
        function updateScreenMediaConstraints(track, constraint) {
            if (self.videoResolutionScreen) {
                $timeout(function () {
                    // settings does not show the right width and height immediately, but updates after brief interval.
                    var settings = track.getSettings();
                    if (
                        !settings ||
                        settings.displaySurface == 'monitor' ||
                        (settings.displaySurface === undefined &&
                            settings.deviceId &&
                            settings.deviceId.startsWith('screen:'))
                    ) {
                        // do not apply width/height for app sharing or tab sharing. it causes cropping.
                        logService.log(
                            'videoroomCtrl screen-media-constraint shared=' +
                                settings.width +
                                'x' +
                                settings.height +
                                ' screen=' +
                                $window.screen.width +
                                'x' +
                                $window.screen.height +
                                ' max=' +
                                self.videoResolutionScreen[0] +
                                'x' +
                                self.videoResolutionScreen[1]
                        );
                        if (
                            settings &&
                            settings.width &&
                            settings.height &&
                            $window.screen &&
                            (settings.width != $window.screen.width || settings.height != $window.screen.height) &&
                            ($window.screen.width > self.videoResolutionScreen[0] ||
                                $window.screen.height > self.videoResolutionScreen[1] ||
                                settings.width > self.videoResolutionScreen[0] ||
                                settings.height > self.videoResolutionScreen[1])
                        ) {
                            // ANYAM-23878 - condition when applying height crops - large monitors - launched from one, shared another.
                            // use both min and max for width+height, but calculate based on shared ratio and desired constraint.
                            var ratioShared = settings.width / settings.height;
                            var ratioMax = self.videoResolutionScreen[0] / self.videoResolutionScreen[1];
                            var width, height;
                            if (ratioShared < ratioMax) {
                                height = self.videoResolutionScreen[1];
                                width = ratioShared * height;
                            } else {
                                width = self.videoResolutionScreen[0];
                                height = width / ratioShared;
                            }
                            constraint.width = { min: width, max: width };
                            constraint.height = { min: height, max: height };
                            logService.log('videoroomCtrl setting max/min width/height to ' + width + 'x' + height);
                        } else {
                            // do not specify both max width+height, ANYAM-23878, as that does not work.
                            logService.log(
                                'videoroomCtrl setting max width/height to ' +
                                    self.videoResolutionScreen[0] +
                                    'x' +
                                    self.videoResolutionScreen[1]
                            );
                            constraint.width = { ideal: self.videoResolutionScreen[0] };
                            constraint.height = { ideal: self.videoResolutionScreen[1] };
                        }
                    }
                    constraint.resizeMode = 'none';
                    track.applyConstraints(constraint).catch(function (err) {
                        logger.error(
                            'updateScreenMediaConstraints',
                            'failed to apply width and height for screen stream',
                            err
                        );
                    });
                }, 1000);
            }
        }
        // To hangup the SIP call for the screen share publisher.
        function doScreenHangup() {
            var hangup = { request: 'hangup' };
            self.screensipcall.send({ message: hangup });
            self.screensipcall.state.call = 'terminating';
            self.screensipcall.hangup();
            analyticsWrapperService.eventTrack('Meeting - screen share call - disconnected', { sfuEvent: true });
        }

        // To start the screen share publisher in the video room. All the events and messages related to this
        // plugin attachment is also handled here.
        function startScreenShare() {
            if (
                self.screenshareState == 'initiating' ||
                self.screenshareState == 'active' ||
                self.screenshareState == 'stopped'
            ) {
                logger.warn('startScreenShare', `screen publisher already ${self.screenshareState}... returning`);
                return;
            }

            analyticsWrapperService.eventTrack('Meeting - screen share call - starting', { sfuEvent: true });
            var sendRestartPlayOnConnect = false;

            if (self.screenshareState != 'disconnected') {
                self.screenshareState = 'initiating';
            }

            var plugin = null;
            logService.log('videoroomCtrl screen publisher, attach plugin');
            self.janus.attach({
                plugin: self.newplugin ? 'janus.plugin.anymeeting' : 'janus.plugin.videoroom',
                handle_type: 'videoroom',
                opaqueId: self.opaqueId,
                success: function (pluginHandle) {
                    // store the plugin, and check which screen or window needs publishing.
                    analyticsWrapperService.eventTrack('Meeting - screen share call - connected', { sfuEvent: true });
                    self.screenshare = plugin = pluginHandle;
                    logService.log(
                        'videoroomCtrl screen publisher, plugin attached! (' +
                            self.screenshare.getPlugin() +
                            ', id=' +
                            self.screenshare.getId() +
                            ')'
                    );

                    self.screenshare.state = {};
                    self.screenshare.state.call = 'starting';
                    self.preShareScreen();
                },
                error: function (error) {
                    analyticsWrapperService.eventTrack('Meeting - screen share call - error', { sfuEvent: true });
                    logger.error(
                        'startScreenShare->janus.attach.error',
                        'screen publisher, error attaching plugin...',
                        error
                    );

                    if (self.screenshareState != 'disconnected' && self.screenshareState != 'stopped') {
                        self.screenshareState = null;
                    }

                    if (self.shouldReattachPluginAfterError(error)) {
                        $timeout(() => self.recreateScreenPublishPlugin(), 0);

                        // videoConnectService.coreError will not be called
                        return true;
                    }

                    return false;
                },
                mediaState: function (medium, on) {
                    logService.log(
                        'videoroomCtrl screen publisher videoroom plugin ' +
                            (on ? 'started' : 'stopped') +
                            ' receiving our ' +
                            medium
                    );
                    plugin.state.media = !!on;

                    if (on) {
                        self.screenRepublishRetry = 0;
                        self.cancelScreenRepublishTimer();
                    }

                    if (on && !plugin.state.mediaInitiated) {
                        plugin.state.mediaInitiated = self.iceMediaInitiated = true;
                    }
                },
                webrtcState: function (on, reason) {
                    logService.log(
                        'videoroomCtrl videoroom screen publisher says our WebRTC PeerConnection is ' +
                            (on ? 'up' : 'down') +
                            ' now, reason=' +
                            reason
                    );

                    plugin.state.webrtc = !!on;
                    var plugin0 = self.screenshare;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log(
                            'videoroomCtrl screen, ignoring webrtcState ' + on + ' as not for current plugin'
                        );
                        return;
                    }
                    self.sendStatsUpdate(on, plugin);
                },
                iceState: function (state) {
                    logService.log('videoroomCtrl videoroom screen publisher iceConnectionState updated:', state);
                    plugin.state.ice = state;

                    var plugin0 = self.screenshare;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log(
                            'videoroomCtrl screen, ignoring iceState ' + state + ' as not for current plugin'
                        );
                        self.iceRestartCancel(plugin);
                        return;
                    }

                    if (state == 'disconnected') {
                        self.iceRestartAfter(self.screenshare, 'screen-send');
                    } else if (state == 'connected') {
                        if (self.screenshare) {
                            self.iceRestartCancel(self.screenshare);
                        }
                        if (self.screenshare && self.screenshare.webrtcStuff) {
                            logService.log('videoroomCtrl applying getStats to outgoing screenshare peer connection');
                            self.applyGetStats(
                                self.screenshare.webrtcStuff.pc,
                                connectivityService.callMediaTypes.SCREENSHARE,
                                { transmissionType: 'sent', mediaType: 'video' }
                            );
                        }
                    }
                },
                slowLink: function (uplink, lost) {
                    var plugin0 = self.screenshare;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl screen, ignoring slowlink as not for current plugin');
                        return;
                    }
                    if (!uplink) {
                        self.onSlowLink('screen', true, lost);
                    }
                },
                onmessage: function (msg, jsep) {
                    logger.log('startScreenShare->janus.attach.onmessage', 'videoroom screen, got a message', msg);

                    var event = msg.anymeeting || msg.videoroom || msg.sip;
                    if (event === 'joined') {
                        // When joined, start publishing the local video stream of the screen or window.
                        // No audio is used.

                        self.myscreenid = msg.id;
                        self.screenpvtid = msg.private_id;

                        plugin.state.call = 'joined';
                        logService.log(
                            'videoroomCtrl videoroom screen, joined room ' + msg.room + ' with ID ' + self.myscreenid
                        );

                        //ScreenShare window selection screen open

                        self.msgflowEvent('peer-connection:joined', { type: 'screen-send', reason: 'joined' });
                        self.createOfferForScreen();
                    } else if (event == 'event') {
                        var plugin0 = self.screenshare;

                        if (msg.error) {
                            if (!plugin0 || plugin !== plugin0) {
                                logService.warn(
                                    'videoroomCtrl screen, ignoring error: ' + msg.error + ', as not for current plugin'
                                );
                                return;
                            }

                            logger.error(
                                'startScreenShare->janus.attach.onmessage',
                                'videoroom screen share error received',
                                msg.error
                            );

                            self.handleScreenPublishPluginError(msg);
                        } else if (msg.configured) {
                            if (!plugin0 || plugin !== plugin0) {
                                logService.log('videoroomCtrl screen, ignoring configured, as not for current plugin');
                                return;
                            }

                            sendRestartPlayOnConnect = self.screenshareState == 'disconnected';

                            if (msg.configured == 'ok') {
                                plugin._configured = true;
                                if (self.screenshareState != 'active' && self.screenshare.state.call == 'started') {
                                    logService.log('videoroomCtrl setIsHostingSFUScreenShare(true) on configured');
                                    self.setIsHostingSFUScreenShare(true);
                                    self.screenshareState = 'active';
                                }
                            }

                            if (msg.configured == 'ok' && sendRestartPlayOnConnect) {
                                sendRestartPlayOnConnect = false;
                                // inform all the other attendees to restart our screen video feed.
                                self.sendRestartVideoPlay(true);

                                $rootScope.$broadcast('sfu-screenshare-disconnected', {
                                    value: false,
                                    isFilePlay: self.fileplay
                                });
                            }
                        }
                    }

                    if (jsep !== undefined && jsep !== null) {
                        // if SDP is present, handle the SDP.
                        logService.log('videoroomCtrl videoroom screen, handling SDP as well...');
                        logService.log(jsep);

                        self.customizeSdp(jsep, true, true, undefined, true);

                        self.screenshare.handleRemoteJsep({ jsep: jsep });
                    }
                },
                onlocalstream: function (stream) {
                    // local screen share stream is obtained.
                    logService.log('videoroomCtrl videoroom screen, got a local stream');
                    logService.log(stream);

                    var stopAllTracks = function (stream) {
                        var allTracks = stream.getTracks();
                        for (var j = 0; allTracks && j < allTracks.length; ++j) {
                            allTracks[j].stop();
                        }
                    };

                    var plugin0 = self.screenshare;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log(
                            'videoroomCtrl videoroom screen, ignoring onlocalstream: as not for current plugin'
                        );
                        stopAllTracks(stream);
                        return;
                    }

                    // do not continue we are not the owner anymore, unless screen video is used. createOfferFromScreen will call stopScreenShare.
                    if (!self.isScreenVideo && self.screenshareOwner && self.screenshareOwner != self.attendantId) {
                        logService.log(
                            'videoroomCtrl videoroom screen, ignoring onlocalstream: someone else started share'
                        );
                        stopAllTracks(stream);
                        return;
                    }

                    // do not continue if the host disabled the ability to share screen.
                    if (meetingService.isAllowedByHostSecuritySettings('canShareScreenOrVideo') === false) {
                        logService.log(
                            'videoroomCtrl videoroom screen, ignoring onlocalstream: host security settings disabled'
                        );
                        stopAllTracks(stream);
                        return;
                    }

                    self.screenstream = stream;

                    if (self.fileplay) {
                        // stop audio track to avoid audio video sync delay for video (ANYAM-14856).
                        self.screenstream = stream.clone(); //  original with audio+video is used for SIP plugin later.
                        self.fileplaystream = stream; // so that it can be cleaned up

                        var audioTracks = stream.getAudioTracks();
                        for (var i = 0; audioTracks && i < audioTracks.length; ++i) {
                            audioTracks[i].stop();
                        }
                    }

                    self.screenstream.oninactive = self.onScreenShareInactive;
                    if (!self.fileplay && !self.isScreenVideo) {
                        $rootScope.$broadcast('sfu-screenshare-stream-started', { stream: stream });
                    }

                    if (self.e2ee) {
                        self.e2eeSetupSender(plugin, stream);
                    }

                    var videoTracks = stream.getVideoTracks();
                    if (!self.fileplay && videoTracks && videoTracks.length > 0) {
                        try {
                            videoTracks[0].contentHint = 'text';
                        } catch (err) {
                            logger.warn(
                                'startScreenShare->janus.attach.onlocalstream',
                                'failed to set contentHint for screen stream',
                                err
                            );
                        }

                        if (self.videoOnScreen && self.videoOnScreenData.stream) {
                            self.onVideoOnScreenShareStream(stream); // updates the frame rate.
                        } else if (self.videoResolutionScreen) {
                            if (self.VDIRef.getVdiType() !== executionEnvironmentEnum.Citrix) {
                                self.updateScreenMediaConstraints(videoTracks[0], {
                                    frameRate: self.frameRateScreen || self.frameRate || 5
                                });
                            }
                        }
                        try {
                            if (!self.VDIRef.shareApplicationScreen) {
                                screenShareType = 'monitor';
                            } else {
                                //sets screenshare type as one of monitor, window, application or browser. not available on older Chrome (Electron 7)
                                var screenShareType = videoTracks[0].getSettings().displaySurface;
                                if (!screenShareType) {
                                    //displaySurface is only available in newer chrome version, electron 7 does not have it
                                    screenShareType = videoTracks[0].getSettings().deviceId.startsWith('screen:')
                                        ? 'monitor'
                                        : 'window';
                                }
                            }
                            contentService.setScreenShareType(screenShareType);

                            // ANYAM-15691 - check app sharing minimized state.
                            if (contentService.getIsSharingAppScreen() && self.detectScreenAppMute) {
                                logService.log('videoroomCtrl screen listen for mute/unmute on app sharing track');

                                videoTracks[0].addEventListener('mute', function (event) {
                                    self.onLocalScreenShareAppMute(true);
                                });
                                videoTracks[0].addEventListener('unmute', function (event) {
                                    self.onLocalScreenShareAppMute(false);
                                });
                            }

                            if (contentService.getIsSharingAppScreen() && self.showPicOnAppMin) {
                                self.createPeriodicAppSnapshotInterval();
                            }

                            analyticsWrapperService.eventTrack(
                                'Meeting - screen share type - ' +
                                    (contentService.getIsSharingAppScreen() ? 'Application' : 'Screen'),
                                { sfuEvent: true }
                            );
                        } catch (err) {
                            logger.warn(
                                'startScreenShare->janus.attach.onlocalstream',
                                'failed to listen to mute/unmute on app sharing track',
                                err
                            );
                        }
                    } else if (self.fileplay) {
                        if (videoTracks && videoTracks.length > 0) {
                            try {
                                videoTracks[0].contentHint = 'motion';
                            } catch (err) {
                                logger.warn(
                                    'startScreenShare->janus.attach.onlocalstream',
                                    'failed to set contentHint for file play',
                                    err
                                );
                            }
                        }

                        self.createFileVideo();
                    }

                    self.createVideoBitrateControl(undefined, true);

                    // Then start the SIP call to the MCU using the SIP plugin (or new plugin).
                    self.startVoiceCallTimer = $timeout(
                        function () {
                            self.startVoiceCallTimer = null;
                            self.startVoiceCall(true);
                        },
                        self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                            self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware
                            ? 1000
                            : 0
                    );
                },
                onremotestream: function (stream) {
                    // The publisher stream is sendonly, we don't expect anything here
                },
                ondetached: function () {
                    var plugin0 = self.screenshare;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl screen, ignoring ondetached as not for current plugin');
                        return;
                    }

                    logger.warn(
                        'startScreenShare->janus.attach.ondetached',
                        'videoroom screen, got forced detached from server, we stop screenshare'
                    );

                    // timeout needed to delay our detach(withRequest) after detach(noRequest) of janus.js to avoid error from server
                    $timeout(function () {
                        self.stopScreenShare();
                    }, 0);
                },
                oncleanup: function () {
                    var plugin0 = self.screenshare;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.log('videoroomCtrl screen, ignoring oncleanup as not for current plugin');
                        return;
                    }

                    logService.log('videoroomCtrl videoroom screen, got a cleanup notification');
                    //removeVideoElement('myscreen');

                    if (self.screenstream) {
                        self.screenstream.oninactive = null; // to avoid calling stopScreenShare again.
                    }

                    self.screenstream = null;

                    delete plugin._configured;

                    if (self.fileplaystream) {
                        var videoTracks = self.fileplaystream.getVideoTracks();
                        for (var i = 0; videoTracks && i < videoTracks.length; ++i) {
                            videoTracks[i].stop();
                        }
                        self.fileplaystream = null;
                    }

                    self.iceRestartCancel(self.screenshare);

                    if (self.screenshareState == 'disconnected' || self.screenshareState == 'stopped') {
                        logService.log('videoroomCtrl SFU ScreenShare Unrequested Disconnect');

                        self.stopScreenShare();

                        if (meetingService.isWebinar() === false) {
                            notificationService.show(
                                localizationService.translate(
                                    'SCREENSHARE.NOTIFICATIONS.PUBLISHED_MEDIA_STOPPED_AS_WE_ATTEMPT_TO_RECONNECT'
                                )
                            );
                        }
                    } else {
                        // it should not come here unless oncleanup was called without stopScreenShare.
                        if (self.screenshare && !self.screenshare.detaching) {
                            logger.error(
                                'startScreenShare->janus.attach.oncleanup',
                                'videoroom screen, failed to create peer connection, aborting'
                            );
                            if (self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware) {
                                self.handleTrackCloseOnVmware();
                            } else {
                                self.showAlert(
                                    'Failed to share your content, please reload the application and try again',
                                    'Unexpected Failure'
                                );
                                $timeout(function () {
                                    // timeout needed to avoid calling oncleanup within oncleanup.
                                    self.stopScreenShare();
                                });
                            }
                        }
                    }

                    self.cleanUpScreenShareOwner();
                    self.destroyVideoBitrateControl(undefined, true);
                    self.enterCompactIfReconnect = true;
                }
            });
        }

        async function createOfferForScreen(iceRestart) {
            // This is our session, publish our stream
            logService.log('videoroomCtrl negotiating WebRTC stream for our screen (capture screen)');
            var media = {
                video: !self.fileplay ? self.capture : true,
                audioRecv: false,
                audioSend: !!self.fileplay,
                videoRecv: false
            };
            if (!self.fileplay) {
                media.screenshareFrameRate = self.frameRateScreen || self.frameRate || 5;
            }

            var screenshareStream;
            if (self.screenstreamClone) {
                logService.log('videoroomCtrl using screenstream clone for offer');
                screenshareStream = self.screenstreamClone;
                self.screenstreamClone = null; // do not use it again.
            } else if (
                self.screenshareState === 'disconnected' &&
                self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware
            ) {
                // ANYAM-101418. Workaround for VMware, because it doesn't check if cloned streams exist,
                // and it removes the red frame around shared window on any stream/videotrack is stopped.
                screenshareStream = await screenShareService.recreateCamaroSfuScreenShareStream();
            } else if (iceRestart && self.screenstream) {
                logService.log('videoroomCtrl using existing screenstream for offer');
                screenshareStream = self.screenstream.clone();
                self.screenstream.oninactive = null; // to avoid calling stopScreenShare again.
                var videoTracks1 = self.screenstream.getVideoTracks();
                for (var i = 0; videoTracks1 && i < videoTracks1.length; ++i) {
                    videoTracks1[i].stop();
                }
                if (self.fileplay) {
                    var audioTracks1 = self.screenstream.getAudioTracks();
                    for (var j = 0; audioTracks1 && j < audioTracks1.length; ++j) {
                        audioTracks1[j].stop();
                    }
                    media.replaceAudio = true;
                }
                self.screenstream = null;
                media.replaceVideo = true;
            } else if (!self.fileplay && helperService.isElectron()) {
                logService.log('videoroomCtrl using camaro screen stream for offer');
                screenshareStream = screenShareService.getCamaroSfuScreenShareStream();
                if (screenshareStream) {
                    var videoTracks = screenshareStream.getVideoTracks();
                    if (videoTracks && videoTracks.length > 0) {
                        if (self.videoOnScreen && self.videoOnScreenData.stream) {
                            self.onVideoOnScreenShareStream(screenshareStream); // updates the frame rate.
                        } else {
                            if (self.VDIRef.getVdiType() !== executionEnvironmentEnum.Citrix) {
                                self.updateScreenMediaConstraints(videoTracks[0], {
                                    frameRate: media.screenshareFrameRate
                                });
                            }
                        }
                    }
                }
            } else if (self.fileplay) {
                logService.log('videoroomCtrl using file play capture stream');
                screenshareStream = self.fileVideo.captureStream();
                // self.fileVideo.play();
                if (screenshareStream) {
                    var videoTracks2 = screenshareStream.getVideoTracks();
                    if (videoTracks2 && videoTracks2.length > 0) {
                        // ANYAM-71741 - workaround for captureStream bug in M88+
                        // use a canvas to periodically copy video to, and use captureStream from canvas to send to peer connection.
                        // re-add audio track to this stream too.
                        if (
                            $window.Janus.webRTCAdapter.browserDetails.browser === 'chrome' &&
                            $window.Janus.webRTCAdapter.browserDetails.version >= 88
                        ) {
                            logService.log('videoroomCtrl - starting workaround for captureStream bug in M88+');
                            if (self.anyam_71741 && self.anyam_71741.interval) {
                                $interval.cancel(self.anyam_71741.interval);
                            }
                            var data = (self.anyam_71741 = {});
                            data.canvas = document.createElement('canvas');
                            data.stream = data.canvas.captureStream();
                            var oldscreenstream = screenshareStream;
                            screenshareStream = data.stream;
                            var audioTracks2 = oldscreenstream.getAudioTracks();
                            for (var k = 0; audioTracks2 && k < audioTracks2.length; ++k) {
                                screenshareStream.addTrack(audioTracks2[k]);
                            }

                            data.interval = $interval(function () {
                                if (!self.fileVideo) {
                                    $interval.cancel(data.interval);
                                    delete self.anyam_71741;
                                    logService.log('videoroomCtrl - stopping workaround for captureStream bug in M88+');
                                    return;
                                }
                                var width = self.fileVideo.videoWidth;
                                var height = self.fileVideo.videoHeight;
                                data.canvas.width = width;
                                data.canvas.height = height;
                                data.canvas.getContext('2d').drawImage(self.fileVideo, 0, 0, width, height);
                            }, 1000 / (self.frameRateFile || self.frameRate || 30));
                        }

                        var constraints2 = { frameRate: self.frameRateFile || 30 };
                        if (self.videoResolutionFile) {
                            constraints2.width = { max: self.videoResolutionFile[0] };
                            constraints2.height = { max: self.videoResolutionFile[1] };
                        }
                        videoTracks2[0]
                            .applyConstraints(constraints2)
                            .then(function () {
                                logService.log('videoroomCtrl fileplay set constraints');
                            })
                            .catch(function (err) {
                                logger.error(
                                    'createOfferForScreen',
                                    'failed to set width and height for electron screen stream',
                                    err
                                );
                            });
                    }
                }
            }

            const plugin = self.screenshare;
            self.screenshare.createOffer({
                iceRestart: !!iceRestart,
                media: media,
                success: function (jsep) {
                    const plugin0 = self.screenshare;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.warn(
                            'createOfferForScreen->screenshare.createOffer.success',
                            'ignoring success as not for current plugin'
                        );

                        return;
                    }

                    logService.log('videoroomCtrl user selected a window for screensharing');

                    if (self.reuseScreenSDP.enable && !self.fileplay) {
                        self.reuseScreenSDP.saved = jsep;
                    }

                    // do not allow multiple content share unless multishare is enabled.
                    if (
                        (!self.multishare || !self.isScreenVideo) &&
                        self.screenshareOwner &&
                        self.screenshareOwner != self.attendantId
                    ) {
                        logger.warn(
                            'createOfferForScreen->screenshare.createOffer.success',
                            'already sharing content from ' +
                                self.screenshareOwner +
                                ', cannot proceed for ' +
                                self.attendantId
                        );
                        self.screenshare.state.call = 'stopping';
                        self.stopScreenShare(true);
                        self.showAlert(
                            localizationService.translate('SCREENSHARE.DIALOG.PLEASE_TRY_AGAIN'),
                            localizationService.translate('SCREENSHARE.DIALOG.CAN_NOT_SHARE_CONTENT')
                        );
                        return;
                    }

                    // do not continue if the host disabled the ability to share screen.
                    if (meetingService.isAllowedByHostSecuritySettings('canShareScreenOrVideo') === false) {
                        logService.log(
                            'videoroomCtrl screen share ignoring createOffer success: host security settings disabled'
                        );

                        self.screenshare.state.call = 'stopping';
                        self.stopScreenShare(true);

                        $rootScope.$broadcast('notify-of-security-change');

                        return;
                    }

                    if (!iceRestart && !self.isScreenVideo) {
                        // if iceRestart, then server already knows that this is playing.
                        logService.log('videoroomCtrl sending playContent screenshare, fileplay=' + self.fileplay);
                        contentService.playContent('screenshare', undefined, undefined, self.fileplay);
                    }

                    logService.log('videoroomCtrl videoroom screen, got publisher SDP!');
                    logService.log(jsep);
                    var bitrate = (self.screenshare.state.bitrate = self.getVideoBitrate(true));
                    var publish = { request: 'configure', audio: true, video: true, bitrate: bitrate };

                    // set the videocodec attribute if needed.
                    var videocodec = (!self.fileplay ? self.videocodecScreen : self.videocodecFile) || self.videocodec;
                    if (videocodec && videocodec != 'vp8') {
                        publish.videocodec =
                            videocodec != 'auto' ? videocodec : self.sendScreenVideoToFS ? 'vp8' : 'vp9';
                        self.screenshare.state.videocodec = publish.videocodec;
                    }

                    sendToScreenPublishPlugin({ message: publish, jsep: jsep });

                    self.screenshare.state.call = 'started';
                },
                error: function (error) {
                    const plugin0 = self.screenshare;
                    if (!plugin0 || plugin !== plugin0) {
                        logService.warn(
                            'createOfferForScreen->screenshare.createOffer.error',
                            'ignoring error as not for current plugin',
                            error
                        );

                        return;
                    }

                    var loggableErr = error && error.message ? error.message : error;
                    var cancelled = false;
                    var isCatalinaError = false;

                    if (loggableErr === 'Permission denied') {
                        logService.log('videoroomCtrl user cancelled Screenshare initiation');
                        cancelled = true;
                    } else if (helperService.isChromeOSXCatalina() && loggableErr === 'Permission denied by system') {
                        isCatalinaError = true;
                    } else {
                        logger.error(
                            'createOfferForScreen->screenshare.createOffer.error',
                            'videoroom screen, WebRTC error',
                            loggableErr
                        );
                    }

                    self.screenshare.state.call = 'stopping';
                    self.stopScreenShare(true);

                    if (!cancelled) {
                        if (isCatalinaError) {
                            var link = supportLinkService.getSupportLink('catalinaScreenShare');
                            self.showAlert(
                                localizationService.translate(
                                    'SCREENSHARE.DIALOG.YOUR_MAC_NEEDS_PERMISSION_TO_SCREENSHARE'
                                ),
                                localizationService.translate('SCREENSHARE.DIALOG.CLICK_HERE_TO_SOLVE_THIS_ISSUE', {
                                    link: link
                                }),
                                true
                            );
                        } else {
                            self.showAlert(
                                localizationService.translate(
                                    'SCREENSHARE.DIALOG.WE_ARE_SORRY_THERE_IS_A_PROBLEM_WITH_SCREEN_SHARE'
                                ),
                                localizationService.translate(
                                    'SCREENSHARE.DIALOG.THERE_IS_A_PROBLEM_WITH_SCREEN_SHARE_TRY_AGAIN'
                                )
                            );
                        }
                    }
                },
                customizeSdp: function (jsep) {
                    // do not set min, max, start bitrate for screenshare, because framerate is low, so
                    // bitrate can be very low if no inter frame change is detected.
                    self.customizeSdp(jsep, true, true);
                },
                e2ee: !!self.e2ee,
                rtcConstraints: (!self.fileplay && self.rtcConstraintsScreen) || undefined,
                stream: screenshareStream
            });
        }

        // inform content service about our screen share. for screen video, also inform server and other modules.
        function setIsHostingSFUScreenShare(isHostingSfuScreenShare) {
            logService.log(
                'setIsHostingSFUScreenShare ' + isHostingSfuScreenShare + ' screen video=' + self.isScreenVideo
            );
            contentService.setIsHostingSFUScreenShare(
                isHostingSfuScreenShare,
                self.isScreenVideo,
                self.getSfuSendScreenParam()
            );

            if (self.isScreenVideo) {
                // update the server so that other attendees display the screen video
                data = { value: isHostingSfuScreenShare };
                if (self.refactorPublisherId) {
                    data.publisher = self.getSfuSendScreenParam();
                }
                socketService.send({
                    message: 'sfu-screen-video-state',
                    data: data
                });
                // update the rest of the client, e.g., screen-share-presenter and meeting-active controllers.
                $rootScope.$broadcast('sfu-screen-video-state', { value: isHostingSfuScreenShare });

                if (isHostingSfuScreenShare && self.multisharePrompt == 'alert') {
                    if (
                        meetingService.getCompactModeAvailable() &&
                        !self.fileplay &&
                        connectivityService.getLocalConnectivityState() != 'disconnected' &&
                        self.enterCompactIfReconnect &&
                        storageService.get('launchCompactMode') === true
                    ) {
                        analyticsWrapperService.eventTrack('Meeting - User Automatically Joined Compact Mode Layout', {
                            category: 'Header menu'
                        });
                        $rootScope.$broadcast('enable-compact-mode', true);
                        self.enterCompactIfReconnect = false;
                    }

                    if (self.multisharePrompt == 'alert') {
                        var msg = localizationService.translate(
                            'SCREENSHARE.DIALOG.YOUR_CONTENT_IS_SHARED_AS_A_SECONDARY_VIDEO'
                        );
                        if (
                            helperService.isUniteApplication() ||
                            helperService.getQueryParameter('compactModeInBrowser') === 'true'
                        ) {
                            notificationService.show(msg, 'success');
                        } else {
                            self.showAlert('', msg);
                        }
                    }
                }

                if (!isHostingSfuScreenShare) {
                    $rootScope.$broadcast('enable-compact-mode', false);
                    self.enterCompactIfReconnect = true;
                }

                analyticsWrapperService.eventTrack(
                    'Meeting - Screenvideo ' + (isHostingSfuScreenShare ? 'started' : 'stopped')
                );
            }

            self.updateTouchBar('screen');
        }

        // save the screen share stream for reconnection. must call stopScreenShare or
        // stop the self.screenstream after this.
        function saveScreenshareForReconnection() {
            if (self.screenstream && self.VDIRef.getVdiType() !== executionEnvironmentEnum.VMware) {
                self.screenstreamClone = self.screenstream.clone();
            }
            self.screenshareState = 'disconnected';
            $rootScope.$broadcast('sfu-screenshare-disconnected', {
                value: true,
                isFilePlay: self.fileplay
            });
        }

        function onScreenShareInactive() {
            logService.log('videoroomCtrl on screenshare inactive');
            if (!self.fileplay) {
                self.stopScreenShare();
            }
        }

        // To stop the screen share publish, clean up the screen share plugin handles to both the
        // video room and the SIP plugin. Also hangup the SIP call and stop the publish stream.
        // If reconnecting, it does not clear the state, unless force is true.
        function stopScreenShare(force) {
            logService.log('videoroomCtrl stopScreenShare(force=' + force + ') state=' + self.screenshareState);

            if (self.timerCheckRoomExistsScreen) {
                $timeout.cancel(self.timerCheckRoomExistsScreen);
                self.timerCheckRoomExistsScreen = null;
            }

            if (self.startVoiceCallTimer) {
                $timeout.cancel(self.startVoiceCallTimer);
                self.startVoiceCallTimer = null;
            }

            self.cancelScreenRepublishTimer();

            var screenstream = self.screenstream;

            // since detach may invoke stopScreenShare again, reset it before calling detach,
            // but make sure to stop the stream track afterwards.
            if (self.screenstream) {
                self.screenstream = null;
            }

            if (self.screenshare) {
                // detach may call cleanup, which may call stopScreenShare again.
                // resetting self.screenshare before calling detach prevents duplicate run.
                self.iceRestartCancel(self.screenshare);
                var screenshare = self.screenshare;
                self.screenshare = null;
                self.detachPlugin(screenshare);
            }

            if (screenstream) {
                var tracks1 = screenstream.getTracks();
                for (var i = 0; tracks1 && i < tracks1.length; ++i) {
                    tracks1[i].enabled = false;
                    tracks1[i].stop();
                }
            }

            if (self.screensipcall) {
                self.doScreenHangup();

                self.iceRestartCancel(self.screensipcall);
                var screensipcall = self.screensipcall;
                self.screensipcall = null;
                self.detachPlugin(screensipcall);
            }

            self.clearPeriodicAppSnapshotInterval();
            self.clearLocalScreenShareAppMuteTimer();
            self.onScreenShareMinimized(false, true); // reset prompt/state if app share was minimized.
            self.cancelAdjustScreenPublishBandwidth();

            if (force || (self.screenshareState != 'disconnected' && self.screenshareState != 'stopped')) {
                if (!self.multishare || self.screenshareState || force === 'cleanup') {
                    logService.log('videoroomCtrl setIsHostingSFUScreenShare(false) on stopScreenShare');
                    self.setIsHostingSFUScreenShare(false);
                    if (self.isScreenVideo) {
                        self.isScreenVideo = false; // reset on stop
                        self.setHasScreenAttribute();
                    }
                }

                self.screenshareState = null;

                if (self.fileVideo) {
                    self.removeFileVideo();
                }
                if (self.screenstreamClone) {
                    self.screenstreamClone.oninactive = null;
                    var tracks = self.screenstreamClone.getTracks();
                    for (var j = 0; tracks && j < tracks.length; ++j) {
                        tracks[j].stop();
                    }
                    self.screenstreamClone = null;
                }
            }

            digest();
        }

        // Detect whether screen share is possible or allowed, and prompt for which screen, window or tab.
        function preShareScreen() {
            if (!self.fileplay) {
                //For Electron, we do not need the janus extension to retrieve desktop stream
                //Just check if Electron and screenshare stream already exists
                var camaroWithActiveScreenShareStream =
                    helperService.isElectron() && screenShareService.getCamaroSfuScreenShareStream();

                if (!$window.Janus.isExtensionEnabled() && !camaroWithActiveScreenShareStream) {
                    self.showAlert(
                        localizationService.translate(
                            'SCREENSHARE.DIALOG.YOU_ARE_USING_CHROME_BUT_DONT_HAVE_SCREEN_SHARE_EXTENSION_INSTALLED'
                        ),
                        localizationService.translate(
                            'SCREENSHARE.DIALOG.YOU_ARE_USING_CHROME_BUT_DONT_HAVE_SCREEN_SHARE_EXTENSION_INSTALLED_CLICK_TO_FIX',
                            {
                                link: 'https://chrome.google.com/webstore/detail/janus-webrtc-screensharin/hapfgfdkleiggjjpfpenajgdnfckjpaj'
                            }
                        )
                    );
                    self.screenshareState = null;
                    return;
                }

                self.capture = 'screen';
            }

            self.shareScreen();
        }

        // Join the video room as a screen share publisher participant.
        // Note that the display name has suffix of ' (Screen)'.
        function shareScreen() {
            logService.log('videoroomCtrl screen sharing session created: ' + self.myroom);
            var register = {
                request: 'join',
                room: self.myroom,
                ptype: 'publisher',
                display: helperService.randomString(12) + ' (Screen)'
            };
            self.addPublisherIdToRequest(register, true);
            self.addPinToRequest(register);

            // first check if the room exists. If not, wait to retry, may be node server was restarted.
            let roomCreationRequested = false;
            var checkRoomExists = function () {
                sendToScreenPublishPlugin({
                    message: { request: 'exists', room: self.myroom },
                    success: function (msg) {
                        if (msg.exists !== undefined && self.screenshare) {
                            if (msg.exists && !self.testForceNoRoom) {
                                sendToScreenPublishPlugin({ message: register });
                            } else {
                                logger.error(
                                    'shareScreen->screenshare.send.success',
                                    'screen room does not exist: ' +
                                        self.myroom +
                                        ', retrying request in ' +
                                        self.timeoutCheckRoomExists +
                                        ' ms'
                                );

                                // ANYAM-98792: workaround for Janus room creation
                                if (!roomCreationRequested) {
                                    roomCreationRequested = true;

                                    logger.log(
                                        'shareScreen->screenshare.send.success',
                                        'screen room does not exist => try to create it',
                                        self.myroom
                                    );

                                    socketService.send({ message: 'create-videoroom-if-needed' });
                                }

                                if (self.timerCheckRoomExistsScreen) {
                                    $timeout.cancel(self.timerCheckRoomExistsScreen);
                                    self.timerCheckRoomExistsScreen = null;
                                }

                                self.timerCheckRoomExistsScreen = $timeout(function () {
                                    self.timerCheckRoomExistsScreen = null;
                                    checkRoomExists();
                                }, self.timeoutCheckRoomExists);
                            }
                        } else {
                            logger.warn(
                                'shareScreen->screenshare.send.success',
                                `can not start screen share: msg.exists=${!!msg.exists}; has screenshare plugin=${!!self.screenshare}`
                            );
                        }
                    }
                });
            };
            checkRoomExists();
        }

        function onStartSfuScreenShare() {
            logService.log('videoroomCtrl starting SFU ScreenShare');
            if (self.screenshareState != 'disconnected' && self.screenshareState != 'stopped') {
                // crossbrowser compatibility check.
                // Safari requires getDisplayMedia to be called on click (user gesture), and not wait after plugin is attached.
                if (
                    helperService.isSafari() &&
                    $window.navigator.mediaDevices &&
                    $window.navigator.mediaDevices.getDisplayMedia
                ) {
                    logService.log('videoroomCtrl calling getDisplayMedia on safari before plugin');
                    $window.navigator.mediaDevices.getDisplayMedia({ video: true }).then(
                        function (stream) {
                            try {
                                var frameRate = self.frameRateScreen || self.frameRate || 5;
                                stream.getTracks()[0].applyConstraints({ frameRate: frameRate });
                            } catch (e) {} // ignore
                            self.screenstreamClone = stream; // will be used in createOfferForScreen. TODO: check if this works on reconnection.
                            self.startScreenShare();
                        },
                        function (error) {
                            logger.error('onStartSfuScreenShare', 'error in getDisplayMedia', error);
                            self.stopScreenShare();
                        }
                    );
                } else {
                    var oldValue = self.isScreenVideo;
                    self.isScreenVideo =
                        self.multishare && !!self.screenshareOwner && self.screenshareOwner != self.attendantId; // starting screen share while already active, makes it screen video.
                    if (oldValue != self.isScreenVideo) {
                        self.setHasScreenAttribute();
                    }

                    self.startScreenShare();
                }
            } // otherwise other part of the code will reconnect screenshare.
        }

        function onStopSfuScreenShare() {
            logService.log('videoroomCtrl stopping SFU ScreenShare');
            self.resetIceRestartState('screen-send');
            self.resetIceRestartState('audio', true);
            self.stopScreenShare(true);
        }

        // see ANYAM-14590 - on reconnection of node server socket, sometimes screen-share-presenter is restarted
        // after videoroomCtrl has already dispatched sfu-screenshare-stream-started. This workaround is for the
        // presenter to request the stream again when it detects screen share is started.
        function onScreenSharePresenterStarted() {
            if (self.screenstream) {
                $rootScope.$broadcast('sfu-screenshare-stream-started', { stream: self.screenstream });
            }

            $timeout(function () {
                // timeout of 0 needed so that DOM element is present by then
                const videoElement = $window.$('#localScreenShareFeed')[0];
                if (videoElement) {
                    videoElement.addEventListener('resize', self.onPreviewResize);

                    if (
                        self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                        self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware
                    ) {
                        const videoElementBounds = videoElement.getBoundingClientRect();
                        if (videoElementBounds) {
                            $window
                                .$('#localSfuScreenShareFeedContainer')
                                .width(videoElementBounds.width)
                                .height(videoElementBounds.height);
                        }
                    }
                }
            }, 0);
        }

        function onScreenShareStarted() {
            self.screenshareOwner = contentService.getContentOwner();
            self.fileplay = contentService.getIsFilePlay();
            if (self.screenshareOwner == self.attendantId) {
                $rootScope.$broadcast('apply-low-cpu-mode', { value: true, reason: 'screenshare' });
                // our screen share started. do not start video for this stream unless layout locked
                if (self.layoutLock == 'locked' && !self.fileplay) {
                    self.startVideoPlay(self.screenshareOwner, true, true);
                    self.setScreenDisplay(true);
                }
                if (
                    meetingService.getCompactModeAvailable() &&
                    !self.fileplay &&
                    connectivityService.getLocalConnectivityState() != 'disconnected' &&
                    self.enterCompactIfReconnect &&
                    storageService.get('launchCompactMode') === true
                ) {
                    analyticsWrapperService.eventTrack('Meeting - User Automatically Joined Compact Mode Layout', {
                        category: 'Header menu'
                    });
                    $rootScope.$broadcast('enable-compact-mode', true);
                    self.enterCompactIfReconnect = false;
                }
            } else {
                if (self.screenshareState == 'disconnected' || self.screenshareState == 'stopped') {
                    // stop our reconnection attempt if someone else started
                    logService.log(
                        'videoroomCtrl stopping screenshare publish, as someone else started ' + self.screenshareOwner
                    );
                    self.stopScreenShare(true);
                    self.enterCompactIfReconnect = false;
                }

                // add the screen share video play
                self.startVideoPlay(self.screenshareOwner, true, true);
                self.setScreenDisplay(true);
            }
        }

        function onScreenShareEnded() {
            var owner = self.screenshareOwner;
            self.cleanUpScreenShareOwner();

            if (owner == self.attendantId) {
                $rootScope.$broadcast('apply-low-cpu-mode', { value: false, reason: 'screenshare' });
                $rootScope.$broadcast('enable-compact-mode', false);
                self.enterCompactIfReconnect = true;
            }

            if (self.screenshareState && (!self.multishare || owner == self.attendantId)) {
                // for multishare, stop only if self content share was ended by server.
                logService.log('videoroomCtrl stopping screenshare publish, as it is ended');
                self.stopScreenShare(true);
                self.enterCompactIfReconnect = true;
            }
        }

        function handleTrackCloseOnVmware() {
            self.stopScreenShare();
            let closeButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
            $window.swal(
                {
                    title:
                        closeButtonHtml + 'Failed to share your content, please reload the application and try again',
                    text: 'Unexpected Failure',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: localizationService.translate('COMMON.CLOSE_TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    allowOutsideClick: false,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg'
                },
                function (confirmed) {
                    // VMware - Need to stop tracks to remove the red border around shared screen on alert dismiss
                    let tracks = screenShareService.getCamaroSfuScreenShareStream().getTracks();
                    tracks.forEach(track => track.stop());
                }
            );
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function sendToScreenPublishPlugin(callbacks) {
            if (callbacks.error === undefined) {
                callbacks.error = msg => {
                    logger.error('sendToScreenPublishPlugin', 'initial message', callbacks.message, 'response', msg);
                    self.handleScreenPublishPluginError(msg);
                };
            }

            if (self.screenshare) {
                self.screenshare.send(callbacks);
            }
        }

        function handleScreenPublishPluginError(msg) {
            switch (msg.error_code) {
                case 424: // JANUS_VIDEOROOM_ERROR_JOIN_FIRST
                case 425: // JANUS_VIDEOROOM_ERROR_ALREADY_JOINED
                case 426: // JANUS_VIDEOROOM_ERROR_NO_SUCH_ROOM
                case 432: // JANUS_VIDEOROOM_ERROR_PUBLISHERS_FULL
                case 433: // JANUS_VIDEOROOM_ERROR_UNAUTHORIZED
                case 434: // JANUS_VIDEOROOM_ERROR_ALREADY_PUBLISHED
                case 435: // JANUS_VIDEOROOM_ERROR_NOT_PUBLISHED
                case 437: // JANUS_VIDEOROOM_ERROR_INVALID_SDP
                case 459: // JANUS_ERROR_HANDLE_NOT_FOUND
                case 461: // JANUS_ERROR_PLUGIN_ATTACH
                case 462: // JANUS_ERROR_PLUGIN_MESSAGE (Request prohibitied by AnyMeeting)
                case 466: // JANUS_ERROR_TRICKE_INVALID_STREAM
                case 469: // JANUS_ERROR_UNEXPECTED_ANSWER
                case 471: // JANUS_VIDEOROOM_ERROR_ALREADY_BACKEND
                case 473: // JANUS_ERROR_PLUGIN_SESSION_NOT_FOUND
                case 500: // JANUS_ERROR_INTERNAL_ERROR
                case 502: // JANUS_ERROR_BAD_GATEWAY
                case 503: // JANUS_ERROR_SERVICE_UNAVAILABLE
                case 504: // JANUS_ERROR_GATEWAY_TIMEOUT
                    self.recreateScreenPublishPlugin();
                    break;
                case 436: // JANUS_VIDEOROOM_ERROR_ID_EXISTS
                    // This can happen if Janus has screen share participant,
                    // but client was reconnecting, due to network change
                    self.onErrorUserIdAlreadyExists(false, true, self.screenshare);
                    break;
                case 470: // JANUS_VIDEOROOM_ERROR_ALREADY_DESTROYED
                case 499: // JANUS_VIDEOROOM_ERROR_UNKNOWN_ERROR
                    rejoinScreenPublishConference(msg);
                    break;
                default:
                    if (!self.screenshare.pendingRestart) {
                        notifyUserAndStopScreenshare();
                    } else {
                        logger.log('handleScreenPublishPluginError', 'error ignored because of pendingRestart');
                    }
                    break;
            }
        }

        function recreateScreenPublishPlugin() {
            if (self.rejoinConferenceTimer) {
                logger.log('recreateScreenPublishPlugin', 'will not retry because we are in the rejoining state');
                return;
            }

            self.retryWithExponentialBackoffAndLimit({
                count: self.screenRepublishRetry,
                limit: self.screenRepublishMaxRetries,
                success: timeoutLength => {
                    logger.log('recreateScreenPublishPlugin', `will retry in ${timeoutLength} ms`);
                    self.screenRepublishRetry += 1;
                    self.cancelScreenRepublishTimer();
                    self.screenRepublishTimer = $timeout(function () {
                        self.screenRepublishTimer = null;

                        if (self.rejoinConferenceTimer) {
                            logger.log(
                                'recreateScreenPublishPlugin->retryWithExponentialBackoffAndLimit->success',
                                'will not retry because we are in the rejoining state'
                            );
                            return;
                        }

                        if (self.screenshare) {
                            self.stopScreenShare(true);
                        }

                        self.startScreenShare();
                    }, timeoutLength);
                },
                error: () => {
                    notifyUserAndStopScreenshare();
                }
            });
        }

        function rejoinScreenPublishConference(msg) {
            if (self.rejoinConferenceTimer) {
                logger.log('rejoinScreenPublishConference', 'will not retry because we are in the rejoining state');
                return;
            }

            self.retryWithExponentialBackoffAndLimit({
                count: self.screenRepublishRetry,
                limit: self.screenRepublishMaxRetries,
                success: timeoutLength => {
                    logger.log('rejoinScreenPublishConference', `will retry in ${timeoutLength} ms`);
                    self.screenRepublishRetry += 1;
                    self.prepareForRejoinConference();
                    self.rejoinConferenceAfter(msg.error, timeoutLength, undefined, true);
                },
                error: () => {
                    self.prepareForRejoinConference();
                    $rootScope.$broadcast('sfu-ws-gave-up');
                }
            });
        }

        function notifyUserAndStopScreenshare() {
            self.showAlert(
                localizationService.translate('SCREENSHARE.DIALOG.THERE_WAS_A_PROBLEM_SHARING_SCREEN_PLEASE_TRY_AGAIN')
            );

            if (!self.isScreenVideo && contentService.isContentInitiating()) {
                contentService.cancelContentInitiation();
            }

            if (self.screenshareState == 'disconnected') {
                // a reconnection failed. cleanup.
                self.screenshareState = 'stopping';
            }
            self.screenshare.state.call = 'stopping';
            self.stopScreenShare(true);
        }

        function cancelScreenRepublishTimer() {
            if (self.screenRepublishTimer) {
                $timeout.cancel(self.screenRepublishTimer);
                self.screenRepublishTimer = null;
            }
        }
    }
]);
